<template>
  <report-mobile-shift-rows
    :loading="loading"
    :rows="rows"
    :stats="stats"
    :search="search"
    empty-icon="mdi-food-off"
  ></report-mobile-shift-rows>
</template>

<script>
import CompanyReportTabMeals from "@/components/company/reports/companyTabs/companyReportTabMeals.vue";
import { SHIFTS } from "@/constants/shifts";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import ReportMobileShiftRows from "@/components/report/mobile/ReportMobileShiftRows.vue";
import { hasPeriodRefetch } from "../../hasPeriodRefetch";

/**
 * Mobilni "Obroci" firme: obroci po abecedi sa ukupnom količinom i količinom po smeni. Firme, smene i period
 * su u zaglavlju. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyMobileMeals",
  extends: CompanyReportTabMeals,
  mixins: [hasBarShifts, hasPeriodRefetch("fetchMeals")],
  components: { ReportMobileShiftRows },
  computed: {
    rows() {
      const found = this.search
        ? this.customSearch(this.filteredMeals, [{ value: "name" }], this.search)
        : this.filteredMeals;
      return found
        .filter((meal) => meal.total > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((meal, index) => ({
          key: `${meal.id || meal.name}-${index}`,
          name: meal.name,
          total: meal.total,
          shifts: SHIFTS.map((shift) => ({ id: shift.id, quantity: meal[`shift${shift.id}`]?.quantity || 0 })).filter(
            (shift) => shift.quantity > 0
          ),
        }));
    },
    stats() {
      return [
        { key: "total", label: this.$t("report_desktop.total_meals"), value: this.rows.reduce((sum, row) => sum + row.total, 0) },
        { key: "meals", label: this.$t("meals"), value: this.rows.length },
      ];
    },
  },
};
</script>
